import React from "react";
import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  ListSubheader,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useTranslationHook } from "../../hooks";

export interface TenderAccountEmails {
  accountId: number;
  accountName: string;
  emails: string[];
}

interface EmailRecipientSelectorProps {
  tenderAccountEmails: TenderAccountEmails[];
  value: string[];
  onSelectionChange: (selectedEmails: string[]) => void;
}

const EmailRecipientSelector: React.FC<EmailRecipientSelectorProps> = ({
  tenderAccountEmails,
  value,
  onSelectionChange,
}) => {
  const { t } = useTranslationHook();

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const selectedValue = event.target.value;
    onSelectionChange(typeof selectedValue === "string" ? selectedValue.split(",") : selectedValue);
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="email-recipient-selector-label">
        {t("generic.select-recipients")}
      </InputLabel>
      <Select
        labelId="email-recipient-selector-label"
        multiple
        value={value}
        onChange={handleChange}
        input={<OutlinedInput label={t("generic.select-recipients")} />}
        renderValue={(selected) => selected.join(", ")}
      >
        {tenderAccountEmails.flatMap((account) => [
          <ListSubheader key={`header-${account.accountId}`}>
            {account.accountName}
          </ListSubheader>,
          ...account.emails.map((email) => (
            <MenuItem key={email} value={email}>
              <Checkbox checked={value.includes(email)} />
              <ListItemText primary={email} />
            </MenuItem>
          )),
        ])}
      </Select>
    </FormControl>
  );
};

export default EmailRecipientSelector;
